module.exports = __webpack_public_path__ + "static/media/arrow.084b15f1.svg";